const data = {
    additionalPhoneInfos : [

        {
            "model": "Nokia 106",
            "info": "≈ 15h talk time battery",
            'icon': [ 'clean-battery.svg', 'clean-camera.svg', 'clean-music.svg' ],
            'traveler': false, 
        },
        
        {
            "model": "Nokia 210",
            'info': 'Camera & Facebook', 
            'icon': ['clean-battery.svg', 'icon-consumer-person-plus.svg'],
            'traveler': true, 
        },
        {
            "model": "Nokia 5310",
            'info': 'loud Speakers for Music',
            'icon': [ 'clean-battery.svg', 'clean-music.svg', 'ic_speaker.svg'],
            'traveler': false, 
        },
        {   "model": "Nokia 8110",
            'info': 'WhatsApp, GMail, Outlook', 
            'icon': ['4g.svg', 'clean-battery.svg', 'icon-consumer-person-plus.svg'],
            'traveler': true, 
        },
        {   "model": "Nokia 800 Tough",
            'info': 'robust & connected', 
            'icon': ['4g.svg', 'clean-battery.svg', 'icon-consumer-person-plus.svg'],
            'traveler': true, 
        },
        {
            "model": "Nokia 2720 Flip",
            'info': 'Emergencybutton, WhatsApp', 
            'icon': ['4g.svg', 'clean-battery.svg', 'icon-consumer-person-plus.svg'],
            'traveler': true, 
        },
        {
            "model": "Nokia 105",
            'info': 'best of all worlds', 
            'icon': ['4g.svg', 'clean-battery.svg', 'clean-music.svg'],
            'traveler': true, 
        },
        {
            "model": "Nokia 130",
            'info': 'playful & entertaining', 
            'icon': [ 'clean-camera.svg', 'clean-music.svg', 'clean-games.svg'],
            'traveler': false, 
        },
        {
            "model": "Nokia 216",
            'info': 'stay entertained', 
            'icon': [ 'clean-battery.svg', 'icon-consumer-person-plus.svg', 'clean-music.svg'],
            'traveler': false,  
        },
        {
            "model": "Nokia 110",
            'info': 'A modern classic', 
            'icon': [ 'clean-battery.svg'],
            'traveler': false, 
        },
        {
            "model": "Nokia 220",
            'info': 'classic with 4G', 
            'icon': [ '4g.svg', 'clean-battery.svg', 'clean-camera.svg'],
            'traveler': true, 
        },
        {
            "model": "Nokia 3310",
            'info': 'A classic reimagined', 
            'icon': ['clean-battery.svg', 'clean-music.svg'],
            'traveler': false, 
        },
    ]      
}
   
export default data; 